module.exports = __webpack_public_path__ + "img/financing-stock-img.c6e64bb2.jpeg";